import * as  React from 'react';
import { ReactChildrenGeneralType } from '../../../models/ReactChildrenGeneralType';


type PopupBodyProps = {
    children: ReactChildrenGeneralType;
    className?: string;
    noPadding?: boolean;
    noOverflow?: boolean;
}

export default function PopupBody({ children, className, noPadding, noOverflow }: PopupBodyProps) {
    return <div className={`popup-form_internal-wrapper ${className} ${noPadding && 'no-padding'} ${noOverflow && 'no-overflow'}`}>
        {children}
    </div>;
}